import { Helmet } from 'react-helmet-async'
import { filter } from 'lodash'
import { useState } from 'react'
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material'
// components
import Iconify from '../components/iconify'
import Scrollbar from '../components/scrollbar'
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user'
// mock
// import USERLIST from '../_mock/user'
import CustomModal from 'src/components/CustomModal/CustomModal'
import { useCompaniesStore } from 'src/store/useCompaniesStore'
import { format } from 'date-fns'
import CreateCompanieForm from 'src/sections/@dashboard/companies/CreateCompanieForm'

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name company', alignRight: false },
  { id: 'alias', label: 'Alias', alignRight: false },
  { id: 'createdAt', label: 'Create at', alignRight: false },
  { id: 'updatedAt', label: 'Updated at', alignRight: false },
]

// ----------------------------------------------------------------------

const APP_BAR_DESKTOP = 92

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1)
  }
  return stabilizedThis.map((el) => el[0])
}

export default function ClientCompaniesPage() {
  const [openCreateCompany, setOpenCreateCompany] = useState(false)
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState('asc')
  const [selected, setSelected] = useState([])
  const [orderBy, setOrderBy] = useState('name')
  const [filterName, setFilterName] = useState('')
  const [rowsPerPage, setRowsPerPage] = useState(5)
  // const handleCompanies = useCompaniesStore((state) => state.handleCompanies)
  const companies = useCompaniesStore((state) => state.companies)

  const handleOpenCreateCompany = () => {
    setOpenCreateCompany(!openCreateCompany)
  }

  const handleCloseCreateUser = () => {
    setOpenCreateCompany(!openCreateCompany)
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = companies.map((n) => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }
    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setPage(0)
    setRowsPerPage(parseInt(event.target.value, 10))
  }

  const handleFilterByName = (event) => {
    setPage(0)
    setFilterName(event.target.value)
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - companies.length) : 0

  const filteredcompanies = applySortFilter(companies, getComparator(order, orderBy), filterName)

  const isNotFound = !filteredcompanies.length && !!filterName

  return (
    <>
      <Helmet>
        <title> User | FDC Dash Admin </title>
      </Helmet>

      <Container sx={{ paddingTop: (APP_BAR_DESKTOP + 24) / 8 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenCreateCompany}>
            New Company
          </Button>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder='"Search company..."'
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={companies.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredcompanies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, name, alias, createdAt, updatedAt } = row

                    const selectedCompanie = selected.indexOf(name) !== -1

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedCompanie}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedCompanie} onChange={(event) => handleClick(event, name)} />
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={name} src={''} />
                            <Typography variant="subtitle2" noWrap>
                              {name}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{alias}</TableCell>
                        <TableCell align="left">
                          {createdAt ? format(new Date(createdAt), 'dd/MM/yyyy:HH:mm') : ''}
                        </TableCell>
                        <TableCell align="left">
                          {updatedAt ? format(new Date(updatedAt), 'dd/MM/yyyy:HH:mm') : ''}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={companies.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <CustomModal
        open={openCreateCompany}
        handleClose={handleCloseCreateUser}
        borderRadius={1}
        width={400}
        padding="1rem"
      >
        <CreateCompanieForm />
      </CustomModal>
    </>
  )
}
